import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
// eslint-disable-next-line import/no-unresolved, import/extensions
import Icon from '../../../common/containers/icon';

// Quality Agent Error Modal - shows error message when quality agent run fails
const QualityAgentErrorModal = _ref => {
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: onClose
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "circle-exclamation",
    className: "text-danger",
    style: {
      marginRight: 10
    }
  }), "Quality Agent Analysis Error"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("p", {
    className: "mb-3"
  }, "An error occurred while running the quality agent analysis. Please try again."), /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-0"
  }, "If the problem persists, please contact support.")), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    onClick: onClose
  }, "Close")));
};
QualityAgentErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
export default QualityAgentErrorModal;